import * as types from "./actionTypes.js";
import * as postedScheduleApi from '../../api/postedScheduleApi.js';

/**
 * Returns a list of posted schedules for a resource from the api.
 * @param {*} resourceId
 */
export function fetchListPostedSchedules(resourceId) {
  return function (dispatch) {
    return postedScheduleApi
      .getListPostedSchedules(resourceId)
      .then(listPostedSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_LIST_POSTED_SCHEDULES_SUCCESS,
          listPostedSchedules
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

/**
 * Returns a 1, 2, 7 or 9 day posted schedule based on what option the user selects.
 * @param {*String} resourceId
 * @param {*} startDate
 * @param {*Int} scheduleFormat
 * @param {*String} resourceName
 */
export function fetchPostedSchedules(startDate, scheduleFormat, postedId, resourceId, resourceName) {
  return function (dispatch) {
    return postedScheduleApi
      .getPostedSchedules(startDate, scheduleFormat, postedId, resourceId, resourceName)
      .then(postedSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_POSTED_SCHEDULES_SUCCESS,
          postedSchedules: postedSchedules[0]
        });
        dispatch({
          type: types.FETCH_POSTED_SCHEDULES_JSON_SUCCESS,
          postedSchedules: postedSchedules[1]
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchListPreviousPostings(resourceId) {
  return function (dispatch) {
    return postedScheduleApi
      .getListPreviousPostings(resourceId)
      .then(listPreviousPostings => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_LIST_PREVIOUS_POSTINGS_SUCCESS,
          listPreviousPostings
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchResourceCollectionInformation(parameters) {
  return function (dispatch) {
    // console.log(parameters);
    return postedScheduleApi
      .getResourceCollectionInformation(parameters)
      .then(resourceCollectionInformation => {
        // console.log(resourceCollectionInformation);
        dispatch({
          type: types.FETCH_RESOURCE_COLLECTION_INFORMATION,
          resourceCollectionInformation
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function createPostedSchedule(parameters) {
  return function (dispatch) {
    return postedScheduleApi
      .createPostedSchedule(parameters)
      .then(response => {
        dispatch({
          type: types.ADD_POSTED_SCHEDULE_SUCCESS,
          response
        })
      }).catch(error => {
        dispatch({
          type: types.ADD_POSTED_SCHEDULE_FAILURE,
          error
        })
    });
  }
}

export function updatePostedScheduleParameters(parameters) {
  return function (dispatch) {
    dispatch({
      type: types.EDIT_POSTED_SCHEDULE_PARAMETERS_SUCCESS,
      parameters
    });
  }
}
